var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": _vm.entity && !_vm.entity.isNew,
          "show-delete":
            _vm.entity &&
            !_vm.entity.deleted &&
            !_vm.entity.isNew &&
            !_vm.readOnlyView &&
            !_vm.isReceive,
          "show-save": _vm.entity && !_vm.entity.deleted && !_vm.readOnlyView,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("purchase-order-side-menu", {
                  ref: "sideMenu",
                  attrs: {
                    "entity-name":
                      _vm.entity.prefix +
                      _vm.entity.purchaseOrderNo +
                      _vm.entity.suffix,
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: {
                    "is-tiled": false,
                    "route-name": _vm.$route.name,
                    vehicle: _vm.quoteVehicle,
                    customer: _vm.quoteCustomer,
                    insurer: _vm.quoteInsurer,
                    "is-receive": _vm.isReceive,
                    "read-only-view": _vm.readOnlyView,
                    "is-lock-purchase-order": _vm.isLockPurchaseOrder,
                  },
                  on: {
                    "display-part": _vm.isDisplayPart,
                    "display-price": _vm.isDisplayPrice,
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _c(
        "save-conflict-modal",
        {
          attrs: { active: _vm.isSaveConflictModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isSaveConflictModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            reload: function ($event) {
              return _vm.reloadData()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Change conflict"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(
              "The data on the server is newer than the local copy. Please reload local data."
            ),
          ]),
        ]
      ),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Purchase Order"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Purchase Order "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [
                      _vm._v(
                        _vm._s(
                          `${_vm.entity.prefix}${_vm.entity.purchaseOrderNo}${_vm.entity.suffix}`
                        )
                      ),
                    ]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isVendorAbnActive,
                "ok-text": "OK",
                "cancel-text": "Cancel",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isVendorAbnActive = $event
                },
                ok: function ($event) {
                  return _vm.saveContinueWithoutAbn()
                },
                cancel: _vm.closeModal,
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("With-Hold Tax"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " This vendor does not have an ABN. You will be required to with hold 49% of the invoice. Ok to Continue? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }